/* Deals page (sections/aa-deals.liquid): count-up of the best discount, optional real countdown,
   quick filters and sorting over the deal cards, and a free-shipping progress pill that follows the cart.
   Adding to the bag is handled by the theme-wide quick add ([data-aa-quick-add] in aa-andes.js). */
(() => {
  const root = document.querySelector('[data-aa-deals]');
  if (!root || root.aaDealsReady) return;
  root.aaDealsReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clp = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-CL');

  // ---- Best discount counts up once it is on screen
  const pct = root.querySelector('[data-aa-count]');
  if (pct && !reduced && 'IntersectionObserver' in window) {
    const target = Number(pct.dataset.aaCount) || 0;
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      const start = performance.now();
      const step = (now) => {
        const k = Math.min(1, (now - start) / 1100);
        const eased = 1 - Math.pow(1 - k, 3);
        pct.textContent = '-' + Math.round(target * eased);
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
    io.observe(pct);
  }

  // ---- Countdown, only when the merchant set a real end date (Chile time, "YYYY-MM-DD HH:MM")
  const timer = root.querySelector('[data-aa-timer]');
  if (timer && root.dataset.end) {
    const m = root.dataset.end.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?$/);
    if (m) {
      // Chile continental is UTC-3 in summer (DST) and UTC-4 in winter; resolve the offset for that date.
      const guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59));
      const tzName = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', timeZoneName: 'shortOffset' }).formatToParts(new Date(guess)).find((p) => p.type === 'timeZoneName')?.value || 'GMT-3';
      const off = Number((tzName.match(/GMT([+-]\d+)/) || [, '-3'])[1]);
      const end = guess - off * 3600 * 1000;
      const cells = {};
      timer.querySelectorAll('[data-t]').forEach((el) => { cells[el.dataset.t] = el; });
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { timer.hidden = true; return; }
        timer.hidden = false;
        const s = Math.floor(left / 1000);
        cells.d.textContent = pad(Math.floor(s / 86400));
        cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
        cells.m.textContent = pad(Math.floor((s % 3600) / 60));
        cells.s.textContent = pad(s % 60);
        setTimeout(tick, 1000);
      };
      tick();
    }
  }

  // ---- Filters and sorting
  const grid = root.querySelector('[data-aa-deals-grid]');
  const count = root.querySelector('[data-aa-deals-count]');
  const none = root.querySelector('[data-aa-deals-none]');
  const sortSel = root.querySelector('[data-aa-deals-sort]');
  let filter = 'all';
  const tests = {
    all: () => true,
    hot: (c) => Number(c.dataset.pct) >= 30,
    cheap: (c) => Number(c.dataset.price) < 1500000,
    free: (c) => c.dataset.free === 'true',
  };
  function apply() {
    if (!grid) return;
    const cards = [...grid.children];
    const key = sortSel ? sortSel.value : 'pct';
    cards.sort((a, b) => key === 'price'
      ? Number(a.dataset.price) - Number(b.dataset.price)
      : Number(b.dataset[key]) - Number(a.dataset[key]));
    let shown = 0;
    cards.forEach((c) => {
      const ok = (tests[filter] || tests.all)(c);
      c.hidden = !ok;
      if (ok) shown += 1;
      grid.appendChild(c);
    });
    if (count) count.textContent = shown;
    if (none) none.hidden = shown > 0;
  }
  root.querySelectorAll('[data-filter]').forEach((btn) => {
    btn.addEventListener('click', () => {
      filter = btn.dataset.filter;
      root.querySelectorAll('.aa-dl-bar__chips [data-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.filter === filter)));
      apply();
    });
  });
  sortSel?.addEventListener('change', apply);
  apply();

  // ---- Free-shipping progress (goal gradient): appears once the bag has something
  const ship = root.querySelector('[data-aa-ship]');
  const goal = Number(root.dataset.free) || 0;
  if (ship && goal > 0) {
    const text = ship.querySelector('[data-aa-ship-text]');
    const bar = ship.querySelector('[data-aa-ship-bar]');
    let last = -1;
    const update = async () => {
      try {
        const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const total = cart.total_price || 0;
        if (total === last) return;
        last = total;
        if (!cart.item_count) { ship.hidden = true; return; }
        const missing = goal - total;
        ship.classList.toggle('is-free', missing <= 0);
        text.innerHTML = missing > 0
          ? `Te faltan <b>${clp(missing)}</b> para el envío gratis`
          : '<b>¡Listo! Tu pedido tiene envío gratis</b>';
        bar.style.width = `${Math.min(100, (total / goal) * 100)}%`;
        ship.hidden = false;
      } catch (e) { /* cart unavailable */ }
    };
    update();
    // The cart bubble changes after every add (quick add, drawer, other tabs via pageshow)
    const icon = document.querySelector('.header-actions__cart-icon');
    if (icon) new MutationObserver(() => setTimeout(update, 250)).observe(icon, { childList: true, subtree: true, characterData: true });
    document.addEventListener('click', (e) => {
      if (e.target instanceof Element && e.target.closest('[data-aa-quick-add]')) setTimeout(update, 1400);
    });
    window.addEventListener('pageshow', update);
  }
})();
